import { Combinator } from '../types';
import { createBlankCriteria } from './createBlankCriteria';
import { createBlankQuery } from './createBlankQuery';

export const createBlankQueryForUserAndEvent = (combinator: Combinator) =>
  createBlankQuery({
    searchQueries: [createBlankCriteria({ combinator })],
  });
